<div class="flex flex-col gap-4">
    @if (isLoading()) {
        <app-loading />
    } @else {
        <div id="legend-list">
            @for (groupedSource of groupedSources(); track groupedSource.name) {
                @if (groupedSource.isActivated && groupedSource.isVisible) {
                    <app-legend-item [groupedSource]="groupedSource" />
                }
            }

            @if (fieldInterventionSources().length) {
                @if (fieldInterventionIsVisible()) {
                    <app-legend-item
                        [fieldInterventionSource]="fieldInterventionSources()[fieldInterventionVisibleIndex()]" />
                }
            }
        </div>

        @if (fieldInterventionSources().length) {
            @if (!fieldInterventionIsVisible()) {
                <app-legend-item [fieldInterventionSource]="fieldInterventionSources()[0]" />
            }
        }

        @for (groupedSource of groupedSources(); track groupedSource.name) {
            @if (!groupedSource.isActivated && !groupedSource.isVisible) {
                <app-legend-item [groupedSource]="groupedSource" />
            }
        }

        <a
            class="!no-underline"
            [routerLink]="['/', RoutePathEnum.PROJECTS, projectBloc.value()!.id, RoutePathEnum.LAYERS]"
            >{{ 'manageDisplay' | transloco }}</a
        >
    }
</div>
